import React from 'react';

export default ({ loading, label='Submit', onClick }) => {
  const buttonLabel = loading ? 'Loading ...' : label;
  return (
    <button onClick={onClick}>{buttonLabel}</button>
  )
}
